import { compileAggregation } from '@/reports/path/utils';

export default {
    namespaced: true,
    actions: {
        async loadRootResource ({ rootGetters, dispatch }, { id: reportId }) {
            await dispatch('savedReports/loadOne', { id: reportId }, { root: true });
            const report = rootGetters['savedReports/reportById'](reportId);
            if (!report) {
                throw new Error('Unable to find report with given id.');
            }

            const { definition: { config: { pageId, featureId, trackTypeId, guideId } = {} } = {} } = report;
            if (pageId) {
                await dispatch('pages/loadOne', { id: pageId }, { root: true });
            } else if (featureId) {
                await dispatch('features/loadOne', { id: featureId }, { root: true });
            } else if (trackTypeId) {
                await dispatch(
                    'trackTypes/loadOne',
                    {
                        id: trackTypeId,
                    },
                    { root: true },
                );
            } else if (guideId) {
                await dispatch(
                    'guides/loadOne',
                    {
                        id: guideId,
                    },
                    { root: true },
                );
            } else {
                throw new Error(`Missing root resource ID for report ${reportId}`);
            }
        },
        async save ({ dispatch }, { path }) {
            const { definition } = path;
            const report = {
                ...path,
                shared: path.shared == null ? true : path.shared,
                aggregation: compileAggregation(path),
                definition: {
                    ...definition,
                    type: 'Path',
                },
            };

            return dispatch(path.id ? 'savedReports/update' : 'savedReports/create', { report }, { root: true });
        },
    },
    getters: {
        rootResourceByReportId: (state, getters, rootState, rootGetters) => (id) => {
            const report = rootGetters['savedReports/reportById'](id);
            if (!report) return;

            const { definition: { config: { pageId, featureId, trackTypeId, guideId } = {} } = {} } = report;

            if (pageId) {
                return rootGetters['pages/pageById'](pageId);
            }
            if (featureId) {
                return rootGetters['features/featureById'](featureId);
            }
            if (trackTypeId) {
                return rootGetters['trackTypes/trackTypeById'](trackTypeId);
            }
            if (guideId) {
                return rootGetters['guides/getGuideById'](guideId);
            }
        },
    },
};
